import _extends from "@babel/runtime/helpers/esm/extends";
var _path;
import * as React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
var SvgSwiggy = function SvgSwiggy(props) {
  return /*#__PURE__*/_jsx("svg", _extends({
    width: 35,
    height: 35,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props, {
    children: _path || (_path = /*#__PURE__*/_jsx("path", {
      d: "m17.535 30.18-.053-.043a66.794 66.794 0 0 1-4.09-5.741c-.575-.96-.947-1.71-.875-1.904.187-.504 3.52-.78 4.546-.323.313.14.304.322.304.43 0 .46-.022 1.698-.022 1.698a.462.462 0 1 0 .926-.003l-.005-3.082c0-.268-.293-.335-.347-.346-.536-.003-1.623-.006-2.792-.006-2.577 0-3.154.106-3.59-.18-.949-.62-2.5-4.802-2.536-7.155-.051-3.318 1.914-6.191 4.683-7.614A8.521 8.521 0 0 1 17.526 5c4.383 0 7.992 3.308 8.472 7.564l.001.011c.088 1.03-5.582 1.248-6.704.949-.172-.046-.215-.223-.215-.298l-.006-2.984a.465.465 0 0 0-.929.002l.01 4.055a.347.347 0 0 0 .282.337h3.518c1.878 0 2.667.217 3.192.616.349.266.483.775.366 1.438-1.054 5.889-7.725 13.186-7.976 13.49h-.002Z",
      fill: "currentColor"
    }))
  }));
};
export default SvgSwiggy;